// @flow
import type { State } from 'store/State';

export function getTheme(state: State): string {
  return state.ui.theme;
}



// WEBPACK FOOTER //
// ./src/store/reducers/ui/theme/selectors.js